import React from 'react';

type Props = { width?: number; height?: number };

export function makeFupIcon(label: string): React.FC<Props> {
  const Icon: React.FC<Props> = ({ width = 60, height = 40 }) => (
    <svg width={width} height={height} viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="58" height="38" rx="6" ry="6" fill="#ffffff" stroke="#0D3559" strokeWidth="2" />
      <text x="30" y="23" textAnchor="middle" fontFamily="Inter, Arial" fontSize="12" fill="#0D3559" fontWeight="700">
        {label}
      </text>
    </svg>
  );
  return Icon;
}

export default makeFupIcon;
